export default ({ name, label }) => (
  name || label
)
